import { buildBaseThemeMapping } from '../../../shared/base-theme';
// audio
import audio from '../audio/audio.m.css';
// backview
import slidingpane from '../base-widgets/sliding-pane.m.css';
import backview from './backview/backview.m.css';
import accordion2 from './base-widgets/accordion2.m.css';
// base-widgets
import tabcontainer from '../base-widgets/tab-container.m.css';
import statusicon from '../book-widgets/status-icon.m.css';
import topicaccordion from '../book-widgets/topicaccordion.m.css';
import topicgroup from './book-widgets/topicgroup.m.css';
// book-widgets
import topicpage from './book-widgets/topicpage.m.css';
// card
import expanded from '../card/expanded.m.css';
import tgf from '../card/tgf.m.css';
// dojo
import checkbox from '../dojo/checkbox.m.css';
import icon from '../dojo/icon.m.css';
import label from '../dojo/label.m.css';
import radio from '../dojo/radio.m.css';
import tooltip from '../dojo/tooltip.m.css';
import carouselview from '../explore-view/carousel-view.m.css';
import chooser from '../explore-view/chooser.m.css';
// explore-view widgets
import contentorder from '../explore-view/content-order.m.css';
import navcard from '../explore-view/nav-card.m.css';
// landing-page
import landingpagegeneral from '../landing-page/general.m.css';
import welcomeview from '../landing-page/welcome-view.m.css';
import content from '../lcc-app/content.m.css';
import footer from './lcc-app/footer.m.css';
// lcc-app
import heading from './lcc-app/heading.m.css';
import splash from './lcc-app/splash.m.css';
// lcc-rcs
import document from '../lcc-rcs/document.m.css';
// learning-activity
import activity from '../learning-activity/activity.m.css';
// prepost-viz
import prepost from '../prepost-viz/prepost-viz.m.css';
import progress from '../prepost-viz/progress-viz.m.css';
// quiz-widgets
import discussion from '../quiz-widgets/discussion.m.css';
import singlestep from '../quiz-widgets/singlestep.m.css';
import drawer from '../table-of-contents/drawer.m.css';
import flashcard from './quiz-widgets/flashcard.m.css';
import mcquestion from './quiz-widgets/mcquestion.m.css';
import pretestreview from './quiz-widgets/pretest-review.m.css';
import prometricreview from './quiz-widgets/prometric-review.m.css';
import prometric from './quiz-widgets/prometric.m.css';
import questionfeedback from './quiz-widgets/questionfeedback.m.css';
import quizfolder from './quiz-widgets/quizfolder.m.css';
// table-of-contents
import toc from '../table-of-contents/toc.m.css';
import trigger from '../table-of-contents/trigger.m.css';
// mc-widgets
import cardbutton from './mc-widgets/card-button.m.css';
import hero from './mc-widgets/hero.m.css';
import toolsbutton from './mc-widgets/tools-button.m.css';
// variants
import mme1Variant from '../variants/mme1.m.css';
// video
import video from '../video/video.m.css';

import dojoProgress from './dojo/progress.m.css';

export default {
	theme: {
		...buildBaseThemeMapping({
			checkbox,
			label,
			icon,
			tooltip,
			radio,
			tabcontainer,
			accordion2,
			slidingpane,
			audio,
			video,
			backview,
			expanded,
			tgf,
			activity,
			heading,
			content,
			splash,
			footer,
			document,
			topicpage,
			topicgroup,
			topicaccordion,
			statusicon,
			prepost,
			progress,
			toc,
			trigger,
			drawer,
			discussion,
			flashcard,
			mcquestion,
			pretestreview,
			prometricreview,
			prometric,
			questionfeedback,
			singlestep,
			quizfolder,
			welcomeview,
			landingpagegeneral,
			contentorder,
			carouselview,
			chooser,
			navcard
		}),
		'@dojo/widgets/progress': dojoProgress,
		'mc-widgets/hero': hero,
		'mc-widgets/card-button': cardbutton,
		'mc-widgets/tools-button': toolsbutton
	},
	variants: {
		mme1: mme1Variant
	}
};
